import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'throttle-debounce';
import customise from '../../../customise/constants/customise';
import useAdditionalScrollMargin from './useAdditionalScrollMargin';

const useUpdateNavBarOnScroll = (sections: string[], domainIdPrefix: string) => {
  const additionalScrollMargin = useAdditionalScrollMargin();
  const [currentElement, setCurrentElement] = useState<string>(sections[0]);
  const navigationBar = document.getElementById(customise.NAVIGATION_BAR_ID);

  const sectionsOffsets = useMemo(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return sections.map(sectionName => {
      const sectionElement = document.getElementById(`${domainIdPrefix}${sectionName}`);
      const rectElement = sectionElement?.getBoundingClientRect();
      const start = rectElement?.top + scrollTop;
      const end = start + sectionElement?.offsetHeight;

      return [start, end];
    });
  }, [sections]);

  const updateNavBar = debounce(50, () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const marginBuffer = 20;
    let delta = navigationBar?.offsetHeight || 0;
    delta += additionalScrollMargin;
    delta += marginBuffer;

    let indexFound = false;
    let indexResult = 0;
    if (sectionsOffsets.length) {
      sectionsOffsets.every((offsetPair, index) => {
        if (indexFound) {
          return false;
        }

        if (
          (scrollTop > offsetPair[0] - delta && scrollTop < offsetPair[1] - delta) ||
          scrollTop < offsetPair[0] - delta
        ) {
          indexResult = index;
          indexFound = true;
        }

        return true;
      });

      if (scrollTop > sectionsOffsets[sectionsOffsets.length - 1][1] - delta) {
        indexResult = sectionsOffsets.length - 1;
      }
    }

    return setCurrentElement(sections[indexResult]);
  });

  useEffect(() => {
    updateNavBar();
    document.addEventListener('scroll', updateNavBar);

    return () => {
      document.removeEventListener('scroll', updateNavBar);
    };
  });

  return { currentElement };
};

export default useUpdateNavBarOnScroll;
